module.exports = __webpack_public_path__ + "static/media/Mask-Group-39.00e6851f.png";